import { connect } from 'react-redux';
import Start from '../components/Start/Start';
import { quitGdlAction } from '../actions/api';
import { setMainPage, setShowTour, reset } from '../actions/app';
import { confirmLogout } from '../actions/auth';
import { setMode } from '../actions/unity';
import { savePreference } from '../actions/preferences';
import { UNITY_MODE } from '../constants/preferences';
import { dismiss, modal } from '../actions/notification';

const mapStateToProps = (state) => {
  return {
    unityMode: state.unity.mode,
    studentAlias: state.auth.alias,
    appName: state.app.name,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startTour: () => {
      dispatch(setShowTour(true));
    },
    gotoPage: (page) => {
      dispatch(setMainPage(page));
    },
    logout: () => {
      dispatch(confirmLogout());
    },
    resetApp: () => {
      dispatch(reset(false));
      dispatch(quitGdlAction());
    },
    setUnityMode: (mode) => {
      dispatch(setMode(mode));
      dispatch(savePreference(UNITY_MODE, mode));
      dispatch(
        modal(
          'Reload Required',
          'You will need to reload the page for this change to take effect.',
          [
            {
              label: 'Reload Later',
              variant: 'light',
              action: (id) => dispatch(dismiss(id)),
            },
            {
              label: 'Reload Now',
              variant: 'primary',
              action: () => window.location.reload(),
            },
          ]
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Start);
